export var SubmissionStatusId;

(function (SubmissionStatusId) {
  SubmissionStatusId["ONGOING"] = "1";
  SubmissionStatusId["PAUSED"] = "2";
  SubmissionStatusId["SUBMITTED"] = "3";
  SubmissionStatusId["BANNED"] = "4";
  SubmissionStatusId["NONE"] = "5";
})(SubmissionStatusId || (SubmissionStatusId = {}));

export var SubmissionStatusName;

(function (SubmissionStatusName) {
  SubmissionStatusName["ONGOING"] = "onGoing";
  SubmissionStatusName["PAUSED"] = "pause";
  SubmissionStatusName["SUBMITTED"] = "submitted";
  SubmissionStatusName["BANNED"] = "banned";
})(SubmissionStatusName || (SubmissionStatusName = {}));

export var submissionStatus = {
  ONGOING: {
    id: SubmissionStatusId.ONGOING,
    name: SubmissionStatusName.ONGOING
  },
  PAUSED: {
    id: SubmissionStatusId.PAUSED,
    name: SubmissionStatusName.PAUSED
  },
  SUBMITTED: {
    id: SubmissionStatusId.SUBMITTED,
    name: SubmissionStatusName.SUBMITTED
  },
  BANNED: {
    id: SubmissionStatusId.BANNED,
    name: SubmissionStatusName.BANNED
  }
};
export var handleSubmissionStatusTagColor = function handleSubmissionStatusTagColor(statusType) {
  switch (statusType) {
    case SubmissionStatusId.BANNED:
      return 'error';

    default:
      return 'default';
  }
};
export var getTranslatedSubmissionStatusName = function getTranslatedSubmissionStatusName(statusId, originalName, translation) {
  switch (statusId) {
    case SubmissionStatusId.ONGOING:
      return translation.statusOnGoing;

    case SubmissionStatusId.PAUSED:
      return translation.statusPaused;

    case SubmissionStatusId.SUBMITTED:
      return translation.statusSubmitted;

    case SubmissionStatusId.BANNED:
      return translation.statusBanned;

    default:
      return originalName;
  }
};